import { Tag } from 'antd';

const FALLBACK_COLORS = [
  'geekblue',
  'blue',
  'cyan',
  'purple',
  'magenta',
  'volcano',
  'orange',
  'gold',
  'lime',
  'green',
];

function hashColor(s) {
  let h = 0;
  for (let i = 0; i < s.length; i += 1) {
    h = (h * 31 + s.charCodeAt(i)) >>> 0;
  }
  return FALLBACK_COLORS[h % FALLBACK_COLORS.length];
}

function resolveColorMapEntry(colorMap, value) {
  if (!colorMap || typeof colorMap !== 'object') return undefined;
  if (Object.prototype.hasOwnProperty.call(colorMap, value)) {
    return colorMap[value];
  }
  const lower = String(value).toLowerCase();
  if (Object.prototype.hasOwnProperty.call(colorMap, lower)) {
    return colorMap[lower];
  }
  return colorMap[String(value)];
}

export function humanizeFilterLabel(value) {
  if (value === null || value === undefined || value === '') return "";
  if (typeof value === 'boolean') return value ? 'Yes' : 'No';
  return String(value)
    .replace(/_/g, ' ')
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

/**
 * Colored tag for enum / boolean cells that use Ant Design column `filters`.
 *
 * @param {{ value: unknown, colorMap?: Record<string, string>, className?: string }} props
 */
export default function FilterValueTag({ value, colorMap, className }) {
  if (value === null || value === undefined || value === '') {
    return <span className="care-filter-value-tag--empty"> - </span>;
  }
  const mapped = resolveColorMapEntry(colorMap, value);
  const color = mapped || hashColor(String(value));
  const label = humanizeFilterLabel(value);

  return (
    <Tag color={color} variant='outlined' className={className}>
      {label}
    </Tag>
  );
}
